import { useLocalization } from '../../context/Localization/localization';
import { GoMotoFunction } from '../GoMoto.types';
import { AppointmentLoanerOrRentalOption } from '../Enums';
import { UseTransportLabelsFunction } from './useTransportLabels.types';

/**
 * Provides label-resolution functions for transportation-related localized display strings.
 * Mirrors the labels pattern used on Dashboard to keep display logic DRY.
 */
export const useTransportLabels: UseTransportLabelsFunction = () => {
    const Localization = useLocalization();

    /**
     * Returns the localized display name for a Loaner or Rental transportation type.
     * Falls back to the combined "Prebooked Rental / Loaner" label when the value is
     * not explicitly Loaner or Rental.
     *
     * @param dmsTransportationType - The DMS transportation classification value.
     * @returns The localized label string.
     */
    const getLoanerOrRentalName: GoMotoFunction<[string], string> = (dmsTransportationType) => {
        switch (dmsTransportationType) {
            case AppointmentLoanerOrRentalOption.Loaner:
                return Localization.Loaner;
            case AppointmentLoanerOrRentalOption.Rental:
                return Localization.Rental;
            default:
                return Localization.PrebookedRentalLoaner;
        }
    };

    return { getLoanerOrRentalName };
};
